import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { selectprocessedData } from "../../../features/importSlice";
import { signInUser } from "../../Utility/Auth";

// const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001/api";

const SelectMCImport = ({
  MCn,
  categoryName,
  masterCategories,
  article_code,
}) => {
  // const auth = signInUser();
  // const { aamarId } = auth;
  const [selectedOption, setSelectedOption] = useState(null);
  const [mcOptions, setMCOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [matched, setMatched] = useState(true);
const data = useSelector(state=>state.importReducer)


  const dispatch = useDispatch();

//   console.log("Select MC ", MCn, masterCategories, article_code, processedData);

  useEffect(() => {
    // const fetchmasterCategories = async () => {
    try {
      // const result = await axios.get(`${BASE_URL}/MC/list/${aamarId}`);
      const options =
        masterCategories?.map((element) => ({
          label: element.name,
          value: element._id,
        })) || [];

      setMCOptions(options);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching masterCategories:", error);
      setLoading(false);
    }
    // };

    // fetchmasterCategories();
  }, [masterCategories]);

  // console.log(masterCategories);

  useEffect(() => {
    const cleanMCn = MCn?.trim()?.toLowerCase();
    const cleanCat = categoryName?.trim()?.toLowerCase();
    const result =
      masterCategories?.find(
        (item) => item?.name?.trim()?.toLowerCase() === cleanMCn
      ) ||
      masterCategories?.find(
        (item) => item?.name?.trim()?.toLowerCase() === cleanCat
      );

    if (!result) {
      setMatched(false);
      setSelectedOption({
        label: "Select Category",
        value: "",
      });
    } else {
      setMatched(true);
      setSelectedOption({
        label: `${result?.name}`,
        value: result?._id,
      });
      setMCHandler({ id: result?._id, name: result?.name });
    }
  }, [MCn, categoryName, mcOptions]);

  // Update Selected Value
  const setMCHandler = ({ id, name }) => {
    const current = data?.processedData?.find(
      (pro) => pro?.article_code === article_code
    );
    if (current && current.master_category === id && current.master_categoryName === name) {
      return;
    }
    const products = data?.processedData?.map((pro) =>
      pro?.article_code === article_code
        ? {
            ...pro,
            master_category: id,
            master_categoryName: name,
          }
        : pro
    );
    dispatch(selectprocessedData(products));
  };

  const handleSelectChange = (selected) => {
    // console.log("Selected MC:", selected);
    setMCHandler({ id: selected.value, name: selected.label });
    setSelectedOption(selected);
  };

  const customStyles = {
    singleValue: (provided, state) => ({
      ...provided,
      color: state.selectProps.matched ? "red" : "black", // Apply color based on 'matched'
    }),
    // Change the border color of the select box
    control: (provided, state) => ({
      ...provided,
      borderColor: state.selectProps.matched ? "red" : "gray", // Conditional border color
      boxShadow: state.isFocused ? "0 0 0 1px red" : "none",
      // "&:hover": {
      //   borderColor: state.selectProps.matched ? "red" : "gray",
      // },
    }),

    // Change the placeholder text color
    placeholder: (provided, state) => ({
      ...provided,
      color: state.selectProps.matched ? "red" : "gray", // Conditional placeholder color
    }),
  };

  return (
    <div>
      <Select
        styles={customStyles}
        matched={!matched}
        value={selectedOption}
        options={mcOptions}
        placeholder={loading ? "Loading masterCategories..." : "Select MC"}
        onChange={handleSelectChange}
        isSearchable
        classNamePrefix="react-select"
      />
    </div>
  );
};

export default SelectMCImport;
